// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__17Jr6","footer":"ModalUpdate_footer__1sjBV"};